import { useTranslation } from 'react-i18next';

/**
 * The pill every surface shows for a test webinar (spec §5.6). One component, so the marker looks
 * the same on the host's list, the public catalogue, the live and on-demand players and the studio.
 */
export const TestWebinarBadge = ({ classNames = '' }: { classNames?: string }) => {
    const { t } = useTranslation();

    const base = 'rounded-full inline-flex items-center font-medium text-sm uppercase whitespace-nowrap px-2 py-0.5 bg-warning btn--warning text-btn-color';

    return (
        <span data-testid="test-webinar-badge" className={[base, classNames].filter(Boolean).join(' ')}>
            {t('Webinar.Test.Badge')}
        </span>
    );
};
